// Wortlaute der Erklärung „Stundenlohnabrechnung“. Regeln für jeden Text: siehe ../help.js.
export default {
  title: "[[hwi]]",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    HourlywageinvoiceWizard: "Abrechnung",
    // Die verwandten Ansichten, in der Reihenfolge, in der sie gespielt werden.
    ProjectDetail: "Projekt",
    SettingsOverview: "Benachrichtigungen",
  },
  // Überschrift des letzten Kapitels, vor dem Namen der jeweiligen Ansicht.
  related: "Zusammenhänge",
  // Beschreibung der Beispielseiten, für Screenreader.
  image: {
    final: "Beispiel [[hwi:eines/einer/eines]] [[hwi.gen]] als PDF",
    draft: "Beispiel eines Abrechnungsentwurfs als PDF",
  },
  step: {
    // ── Der Assistent ──────────────────────────────────────────────────────
    guide: {
      text: "Der Assistent geht in drei Schritten vor. Erst das Projekt, dann der Zeitraum, dann die Suche nach den Berichten.",
    },
    project: {
      text: "Hier wählen Sie das Projekt, dessen [[hwr.pl]] abgerechnet werden. Darunter stehen Dauer, Adresse und leitende Mitarbeitende.",
    },
    range: {
      text: "Der Zeitraum grenzt die Suche ein. Die Punkte an den Tagen zeigen, an welchen Tagen Berichte liegen und wie weit die abgerechnet sind.",
    },
    legend: {
      text: "Rot heißt, kein Bericht dieses Tages ist abgerechnet. Gelb heißt, nur ein Teil davon, grün heißt alle.",
    },
    search: {
      text: "Die Suche holt alle [[hwr.pl]] des Projekts aus dem Zeitraum. Die Kopfzeile sagt, wie viele es geworden sind.",
    },
    table: {
      text: "Eine Zeile je Bericht, mit Kennung, Beschreibung, Ausführungstag und Kategorien. Ein Klick auf die Zeile hakt den Bericht an.",
    },
    billed: {
      text: "Die Spalte Abgerechnet sagt, welcher Bericht schon auf einer Rechnung steht. Ein halbes Häkchen steht für einen Entwurf.",
    },
    mark: {
      text: "Über dieses Menü haken Sie alle Berichte an, nur die noch nicht abgerechneten oder gar keinen.",
    },
    dialog: {
      text: "Abrechnen öffnet dieses Fenster für die angehakten Berichte. Vorher prüft Lewara, ob jede Leistung darin einen Preis hat.",
    },
    warnings: {
      text: "Hier meldet das Fenster, was an den Berichten auffällt. Ein fehlender Preis sperrt die Abrechnung, bis er nachgetragen ist.",
    },
    options: {
      text: "Ein Entwurf setzt an den Berichten nur ein Entwurfsdatum, sie gelten weiter als nicht abgerechnet. Eine eigene Abrechnungsnummer ersetzt die fortlaufende nur auf dem PDF und im Dateinamen.",
    },
    create: {
      text: "Diese Schaltfläche erzeugt die Rechnung als PDF und setzt an jedem Bericht das Abrechnungsdatum. Sie zählt dabei die Rechnungsnummer des Projekts hoch.",
    },
    print: {
      text: "Links steht die fertige Abrechnung mit Rechnungsnummer und Preisen, rechts der Entwurf ohne beides. Mit dem Entwurf prüfen Sie die Mengen, bevor Sie abrechnen.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie von vorn.",
    },

    // ── Zusammenhänge ──────────────────────────────────────────────────────
    "project-positions": {
      text: "Der Stundensatz je Personalrolle steht am Projekt. Fehlt er, meldet ihn die Abrechnung als fehlenden Preis und bleibt gesperrt.",
    },
    "project-prices": {
      text: "Hier steht, wie das Projekt Material und Maschinen verkauft. Beim Aufschlag auf den Einkaufspreis muss dieser Preis am Material stehen.",
    },
    "project-reports": {
      text: "Hier schreibt die Baustelle ihre [[hwr.pl]]. Das Abrechnen setzt an [[hwr:jedem/jeder/jedem]] das Datum, das der Assistent als abgerechnet zeigt.",
    },
    "settings-unbilled": {
      text: "Nicht abgerechnete Berichte meldet die Glocke je Projekt. Ab wie vielen Tagen sie warnt, stellen Sie hier ein.",
    },
  },
}
